module.exports = __webpack_public_path__ + "assets/img/The-Dream-Collective-Website-w960.5ba21d23.jpg";